// تنسيق
import React, { useState, useEffect, lazy, Suspense } from "react";
import { Box, Typography, Paper, Tabs, Tab, CircularProgress, useMediaQuery, useTheme } from "@mui/material";

// ✅ تحميل المكونات عند الحاجة (`lazy loading`) لتحسين الأداء
const GeneralData = lazy(() => import("../components/PagesComponents/DashboardComponents/GeneralData/GeneralData"));
const BranchData = lazy(() => import("../components/PagesComponents/DashboardComponents/BranchData"));
const KitchensDefinition = lazy(() => import("../components/PagesComponents/DashboardComponents/Kitchens/KitchensDefinition"));
const Tables = lazy(() => import("../components/PagesComponents/DashboardComponents/Tables/Tables"));
const CashBanks = lazy(() => import("../components/PagesComponents/DashboardComponents/CashBankslists"));
const TicketTap = lazy(() => import("../components/PagesComponents/DashboardComponents/SupportTicket/TicketTap"));
const InstallTab = lazy(() => import("../components/PagesComponents/DashboardComponents/InstallTab")); // 👈 إضافة الاستيراد
const MyVersionDetails = lazy(() => import("../components/PagesComponents/DashboardComponents/MyVersionDetails"));

const SupportTab = () => (
  <Box sx={{ textAlign: "center", mt: 4 }}>
    <Typography variant="h6" sx={{ mb: 2 }}>الدعم الفني</Typography>
    <Typography>للتواصل مع الدعم الفني يرجى الاتصال على الرقم: <b>123456789</b> أو عبر البريد: <b>support@example.com</b></Typography>
  </Box>
);

const MySystemTab = () => (
  <Box sx={{ textAlign: "center", mt: 4 }}>
    <Typography variant="h6" sx={{ mb: 2 }}>نظامي وباقاتي</Typography>
    <Typography>هنا يمكنك إدارة نظام الاشتراك والباقات الخاصة بك.</Typography>
  </Box>
);

const Dashboard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const [activeTab, setActiveTab] = useState(Number(localStorage.getItem("activeTab")) || 0);

  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  const handleTabChange = (_, newValue) => setActiveTab(newValue);

  const tabs = [
    { label: "البيانات العامة", component: <GeneralData /> },
    { label: "بيانات الفروع", component: <BranchData /> },
    { label: "تعريف المطابخ", component: <KitchensDefinition /> },
    { label: "الطاولات", component: <Tables /> },
    { label: "الخزائن", component: <CashBanks /> },
    { label: "الدعم الفني", component: <TicketTap /> },
    { label: "نظامي وباقاتي", component: <MyVersionDetails /> },
    // { label: "تثبيت التطبيق علي الجهاز", component: <InstallTab /> }, // 👈 استخدم InstallTab هنا
  ];

  return (
    <Box sx={{ 
      padding: { xs: 1, sm: 2, md: 3 }, 
      width: "100%",
      maxWidth: "100vw",
      overflowX: "hidden",
    }}>
      <Typography 
        variant="h5" 
        sx={{ 
          fontSize: { xs: "18px", sm: "22px", md: "28px" },
          fontWeight: "bold",
          mb: { xs: 1, sm: 2 },
        }}
      >
        لوحة التحكم
      </Typography>

      <Paper 
        elevation={isMobile ? 1 : 3}
        sx={{ 
          padding: { xs: 0.5, sm: 1.5, md: 2 }, 
          marginTop: { xs: 1, sm: 2 }, 
          width: "100%",
          borderRadius: { xs: "8px", sm: "12px" },
        }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="تبويبات لوحة التحكم"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            minHeight: { xs: "42px", sm: "48px" },
            "& .MuiTab-root": { 
              fontSize: { xs: "12px", sm: "14px", md: "16px" },
              minHeight: { xs: "42px", sm: "48px" },
              minWidth: { xs: "80px", sm: "100px", md: "120px" },
              padding: { xs: "6px 8px", sm: "8px 12px", md: "12px 16px" },
              textTransform: "none",
              fontWeight: 500,
            },
            "& .MuiTabs-indicator": { 
              backgroundColor: "#EA7C69",
              height: { xs: 2, sm: 3 },
            },
            "& .MuiTabs-scrollButtons": {
              width: { xs: "30px", sm: "40px" },
              "&.Mui-disabled": { opacity: 0.3 },
            },
            "& .MuiTab-root.Mui-selected": {
              color: "#EA7C69",
              fontWeight: 600,
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab 
              key={index} 
              label={tab.label}
            />
          ))}
        </Tabs>

        <Box sx={{ 
          marginTop: { xs: 1, sm: 2 }, 
          minHeight: { xs: "250px", sm: "300px", md: "350px" },
          padding: { xs: 1, sm: 1.5, md: 2 },
          overflowX: "auto",
        }}>
          <Suspense 
            fallback={
              <Box sx={{ 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center", 
                minHeight: { xs: "200px", sm: "250px" } 
              }}>
                <CircularProgress size={isMobile ? 30 : 40} />
              </Box>
            }
          >
            {tabs[activeTab].component}
          </Suspense>
        </Box>
      </Paper>
    </Box>
  );
};

export default Dashboard;
